import { request } from "./request";

const BASE_URL = "/widget";

export default {
  async task(taskId) {
    return await request(`${BASE_URL}/task/${encodeURIComponent(taskId)}`);
  },

  async module(moduleId) {
    return await request(`${BASE_URL}/module/${encodeURIComponent(moduleId)}`);
  },
};
